<template>
  <div v-if="visible">
    <div class="gc_mask" @click="goClose" />
    <div class="modal-top" @click="goClose">
      <!-- <div class="gl_share" :style="`{backgroundImage:url('${imgType}')}`"></div> -->
      <div class="gl_share" :style="{backgroundImage: 'url('+ $t('topHeader.shareImg') +')'}" />

    </div>
  </div>
</template>
<script>
export default {
  props: {
    downShow: {
      type: Boolean,
      default: false
    },
    imgType: {
      type: String,
      default: 'https://img.mingchu.co/ueditor/php/upload/image/20191018/1571387567859008.png'
    }
  },
  data() {
    return {
      visible: this.downShow
    }
  },
  watch: {
    downShow(val) {
      this.visible = val
    }
  },
  mounted() {
    console.log(this.imgType)
  },
  methods: {
    goClose() {
      this.$emit('showDwon', this.visible)
    }
  }
}
</script>
